export const visitGroups = (groups, visitor) => {
	if (groups) {
		groups.forEach(group => {
			visitor(group);
			visitGroups(group.groups, visitor);
		});
	}
};
